export const transformFileName = (str: string) => {
  const strSet = str.split('/');
  return strSet.at(-1) || '';
};
